/**
 * @param {Object} item
 * @returns {String || undefined} targetExternalId
 */
export default (item) => {
    return item?.targExtId
}


/**
 * Deprecated
 * @param {String} externalId - item externalId
 * @returns {String} the target externalId
 *
export default (externalId) => {
    let temp = externalId.split("_"); // SC_externalId_1
        temp.shift(); //get rid of SC prefix
        temp.pop(); // get rid of index suffix
        return temp.join("_"); // put string back together
}
*/